import { AttendState, Meeting, MeetingRecord, MeetingState, OrderMeetingV2 } from 'type/meeting';
import { useState, useEffect } from 'react';
import dayjs from 'dayjs';
import cooperationSDK from 'lib/cooperationSdk';
import APP_ROUTE from 'constant/route';
import qs from 'qs';
import { ApprovalMeetingStatus } from 'constant/approval';
import { getStaffId } from 'data/storage';

export function isRemind({ inviteState, changeLogs, userReadTime, summaryState }: MeetingRecord) {
  if (inviteState === AttendState.TO_BE_CONFIRMED) {
    return true;
  } else if (inviteState === AttendState.JOINED || inviteState === AttendState.ASK_FOR_LEAVE) {
    const logsLength = changeLogs.length;
    if (logsLength > 0) {
      // 会议撤销状态改变
      const lastLogCreateTime = changeLogs[0].createTime;

      if (lastLogCreateTime > userReadTime) {
        return true;
        // 会议已归档
      }
    }

    if (summaryState === 1) {
      return true;
    }
  } else if (inviteState === AttendState.INVITE_WITHDRAW) {
    return true;
  }

  return false;
}

export function useMeetingTaskDate(meetingList: MeetingRecord[]) {
  const [noticeList, setNoticeList] = useState<number[]>([]);
  const [taskList, setTaskList] = useState<number[]>([]);

  useEffect(() => {
    const newNoticeList: number[] = [];
    const newTaskList: number[] = [];

    meetingList.forEach((cur) => {
      const day = dayjs(cur.meeting.beginTime).format('YYYY-MM-DD');
      const timestamp = dayjs(day).valueOf();
      newTaskList.push(timestamp);
      if (isRemind(cur)) {
        newNoticeList.push(timestamp);
      }
    });

    setNoticeList(Array.from(new Set(newNoticeList)));
    setTaskList(Array.from(new Set(newTaskList)));
  }, [meetingList]);

  return {
    noticeList,
    taskList
  };
}

export enum RedirectPage {
  DETAILS = 'details',
  INVITED = 'invited',
  SCHEDULE = 'schedule',
  HOME = 'home',
  APPROVAL = 'approval'
}

export enum RedirectType {
  CANCEL = 'cancel',
  WITHDRAW = 'withdraw',
  REFUSE = 'refuse'
}

type Redirect = {
  page: RedirectPage;
  path: string;
  type?: RedirectType;
};

export function getRedirect(meeting: Meeting, currentStaffId: string): Redirect {
  const me = meeting.members?.find((m) => m.user.staffId === currentStaffId);
  const isContainMyself = !!me && me.createTime;

  const query = qs.parse(location.search.slice(1));
  if (meeting.state === MeetingState.DISBAND || query.type === RedirectType.WITHDRAW) {
    return {
      page: RedirectPage.DETAILS,
      path: `/details/${meeting._id}`,
      type: RedirectType.CANCEL
    };
  }

  // 不在会议邀请名单中
  const attendState = !!me && me.state;
  if (!isContainMyself || attendState === AttendState.INVITE_WITHDRAW || attendState === AttendState.REFUSED) {
    return cooperationSDK.isCoEnv
      ? {
          page: RedirectPage.DETAILS,
          path: `/details/${meeting._id}`,
          type: attendState === AttendState.REFUSED ? RedirectType.REFUSE : RedirectType.WITHDRAW
        }
      : {
          page: query.from === RedirectPage.SCHEDULE ? RedirectPage.SCHEDULE : RedirectPage.HOME,
          path: query.from === RedirectPage.SCHEDULE ? APP_ROUTE.SCHEDULE : APP_ROUTE.HOME
        };
  }

  // 未处理会议邀请
  // if (me?.state === AttendState.TO_BE_CONFIRMED) {
  //   return {
  //     page: RedirectPage.INVITED,
  //     path: `/details/${meeting._id}`
  //   };
  // }

  return {
    page: RedirectPage.DETAILS,
    path: `/details/${meeting._id}`
  };
}

export const shouldShowCancel = (meetingState: MeetingState, redirectType?: RedirectType) => {
  return (
    meetingState === MeetingState.DISBAND ||
    redirectType === RedirectType.CANCEL ||
    redirectType === RedirectType.WITHDRAW ||
    redirectType === RedirectType.REFUSE
  );
};

/**
 * 审批会议过期状态
 */
export const shouldShowApprovalCancel = (status?: ApprovalMeetingStatus) => {
  return status === ApprovalMeetingStatus.Expired || status === ApprovalMeetingStatus.Fail || status === ApprovalMeetingStatus.Revoke;
};

export const includeMasterInMeetingMembers = (meeting: OrderMeetingV2): OrderMeetingV2 => {
  const masterStaffId = meeting.staffId || getStaffId();
  if (!masterStaffId) return meeting;

  const staffIdList = meeting.members?.staffIdList || [];
  if (staffIdList.includes(masterStaffId)) return meeting;

  return {
    ...meeting,
    staffId: meeting.staffId || masterStaffId,
    members: {
      ...meeting.members,
      staffIdList: [masterStaffId, ...staffIdList]
    }
  };
};

// 区分会议预约和会议安排
export const getPageFrom = () => {
  const query = qs.parse(location.search.slice(1));
  if (query.from === RedirectPage.APPROVAL) return { path: APP_ROUTE.APPROVALCENTER, label: '审批中心' };
  return query.from === RedirectPage.SCHEDULE ? { path: APP_ROUTE.SCHEDULE, label: '会议日程' } : { path: APP_ROUTE.HOME, label: '会议室' };
};
